import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'brand-flutter', 'BrandFlutter', [["path",{"d":"M7 14l-3 -3l8 -8h6l-11 11"}],["path",{"d":"M14 21l-5 -5l5 -5h5l-5 5l5 5l-5 0"}]]);